import React from 'react';
import { Github, Twitter, Linkedin, Code2, TestTube, KanbanSquare, Rocket } from 'lucide-react';

export const SITE_CONFIG = {
  name: "WebXHosts",
  domain: "webxhosts.in",
  hero: {
    heading: "Crafting Digital Experiences",
    subheading: "Freelance Web Development, Rigorous Testing, & Agile Project Management.",
    cta: "Start a Project",
  },
  services: [
    {
      title: "Web Development",
      description: "Building responsive, high-performance web applications using modern frameworks like React, Next.js, and Three.js.",
      icon: <Code2 size={40} strokeWidth={1.5} />,
      color: "from-pink-500 to-rose-500"
    },
    {
      title: "Quality Assurance",
      description: "Comprehensive testing strategies including automated E2E, integration, and unit testing to ensure flawless delivery.",
      icon: <TestTube size={40} strokeWidth={1.5} />,
      color: "from-cyan-500 to-blue-500"
    },
    {
      title: "Project Management",
      description: "Agile methodologies, sprint planning, and transparent communication to guide your project from concept to launch.",
      icon: <KanbanSquare size={40} strokeWidth={1.5} />,
      color: "from-purple-500 to-indigo-500"
    },
    {
      title: "Full-Cycle Delivery",
      description: "End-to-end solutions combining development, testing, and management for a seamless product lifecycle.",
      icon: <Rocket size={40} strokeWidth={1.5} />,
      color: "from-amber-400 to-orange-500"
    }
  ],
  contact: {
    email: "hello@webxhosts.in",
    socials: [
      { name: "Github", icon: <Github size={20} />, link: "https://github.com" },
      { name: "Twitter", icon: <Twitter size={20} />, link: "https://twitter.com" },
      { name: "LinkedIn", icon: <Linkedin size={20} />, link: "https://linkedin.com" }
    ]
  }
};